 <template>
  <div class="home-content">
    <div class="title">
      <span>整体数据</span>
    </div>
    <div class="info-box">
      <el-select
        size="small"
        v-model="infoData.viewUnit"
        placeholder="请选择">
        <el-option
          v-for="item in unitOptions"
          :key="'infoData' + item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <template v-if="infoData.viewUnit !== 'now'">
        <el-date-picker
          size="small"
          v-show="infoData.viewUnit === 'day'"
          v-model="infoData.dateTime"
          type="date"
          :picker-options="pickerOptions"
          placeholder="选择日期">
        </el-date-picker>
        <el-date-picker
          size="small"
          v-show="infoData.viewUnit === 'week'"
          v-model="infoData.dateTime"
          type="week"
          format="yyyy 第 WW 周"
          :picker-options="pickerOptions"
          placeholder="选择周">
        </el-date-picker>
        <el-date-picker
          size="small"
          v-show="infoData.viewUnit === 'month'"
          v-model="infoData.dateTime"
          type="month"
          :picker-options="pickerOptions"
          placeholder="选择月">
        </el-date-picker>
        <el-date-picker
          size="small"
          v-show="infoData.viewUnit === 'year'"
          v-model="infoData.dateTime"
          type="year"
          :picker-options="pickerOptions"
          placeholder="选择年">
        </el-date-picker>
        <el-date-picker
          size="small"
          v-show="infoData.viewUnit === 'customize'"
          v-model="infoData.startDate"
          type="date"
          :picker-options="pickerInfoDataStartOptions"
          placeholder="开始时间">
        </el-date-picker>
        <el-date-picker
          size="small"
          v-show="infoData.viewUnit === 'customize'"
          v-model="infoData.endDate"
          type="date"
          :picker-options="pickerInfoDataEndOptions"
          placeholder="结束时间">
        </el-date-picker>
      </template>
      <template v-if="infoData.viewUnit === 'now'">
        <span class="update-time">更新时间：{{ formatData(this.infoData.nowDate, 'Y-M-D hh:mm:ss') }}</span>
        <el-button
          @click="upDateNowDate('infoData')"
          class="update-button"
          size="mini"
          type="primary">
          <img src="../assets/image/home/update.png"/>刷新
        </el-button>
      </template>
      <ul class="info-view">
        <li class="info-item">
          <img class="bg" src="../assets/image/home/bg1.png"/>
          <div class="info-text">
            <div class="order-number">
              {{ this.totalAnalyseData.OrderNum ? (this.totalAnalyseData.OrderNum === 0 ? '暂无数据' : `${this.totalAnalyseData.OrderNum}单`) : '暂无数据' }}
            </div>
            <div class="info-title">成交单</div>
          </div>
        </li>
        <li class="info-item">
          <img class="bg" src="../assets/image/home/bg2.png"/>
          <div class="info-text">
            <div class="order-number">
              {{ this.totalAnalyseData.PriceSum ? (this.totalAnalyseData.PriceSum === 0 ? '暂无数据' : `${this.totalAnalyseData.PriceSum / 100}元`) : '暂无数据' }}
            </div>
            <div class="info-title">成交保费</div>
          </div>
        </li>
        <li class="info-item">
          <img class="bg" src="../assets/image/home/bg3.png"/>
          <div class="info-text">
            <div class="order-number">
              {{ this.totalAnalyseData.SumInsuredSum ? (this.totalAnalyseData.SumInsuredSum === 0 ? '暂无数据' : `${this.totalAnalyseData.SumInsuredSum / 100}元`) : '暂无数据'}}
            </div>
            <div class="info-title">总保额</div>
          </div>
        </li>
      </ul>
    </div>

    <div class="title">
      <span>产品统计</span>
    </div>
    <div class="info-box">
      <el-select
        size="small"
        v-model="productData.viewUnit"
        placeholder="请选择">
        <el-option
          v-for="item in unitOptions"
          :key="'productData' + item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <template v-if="productData.viewUnit !== 'now'">
        <el-date-picker
          size="small"
          v-show="productData.viewUnit === 'day'"
          v-model="productData.dateTime"
          type="date"
          :picker-options="pickerOptions"
          placeholder="选择日期">
        </el-date-picker>
        <el-date-picker
          size="small"
          v-show="productData.viewUnit === 'week'"
          v-model="productData.dateTime"
          type="week"
          :picker-options="pickerOptions"
          format="yyyy 第 WW 周"
          placeholder="选择周">
        </el-date-picker>
        <el-date-picker
          size="small"
          v-show="productData.viewUnit === 'month'"
          v-model="productData.dateTime"
          :picker-options="pickerOptions"
          type="month"
          placeholder="选择月">
        </el-date-picker>
        <el-date-picker
          size="small"
          v-show="productData.viewUnit === 'year'"
          v-model="productData.dateTime"
          :picker-options="pickerOptions"
          type="year"
          placeholder="选择年">
        </el-date-picker>
        <el-date-picker
          size="small"
          v-show="productData.viewUnit === 'customize'"
          v-model="productData.startDate"
          type="date"
          :picker-options="pickerProductDataStartOptions"
          placeholder="开始时间">
        </el-date-picker>
        <el-date-picker
          size="small"
          v-show="productData.viewUnit === 'customize'"
          v-model="productData.endDate"
          type="date"
          :picker-options="pickerProductDataEndOptions"
          placeholder="结束时间">
        </el-date-picker>
      </template>
      <template v-if="productData.viewUnit === 'now'">
        <span class="update-time">更新时间：{{ formatData(this.productData.nowDate, 'Y-M-D hh:mm:ss') }}</span>
        <el-button
          @click="upDateNowDate('productData')"
          class="update-button"
          size="mini"
          type="primary">
          <img src="../assets/image/home/update.png"/>刷新
        </el-button>
      </template>
      <div class="info-view product-view">
        <div class="table">
          <el-table
            :data="goodsAnalyseData ? goodsAnalyseData.GoodsItemList : []"
            border
            style="width: 100%">
            <el-table-column
              prop="GoodsName"
              label="产品名称"
              minWidth="230">
            </el-table-column>
            <el-table-column
              prop="OrderNum"
              label="出单数"
              width="180">
            </el-table-column>
            <el-table-column
              label="保费"
              width="180">
              <template slot-scope="scope">
                <span >{{ scope.row.PriceSum === '' ? '暂无数据' : `${scope.row.PriceSum / 100}元` }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="佣金"
              width="180">
              <template slot-scope="scope">
                <span >{{ scope.row.ProfitSum === '' ? '暂无数据' : `${scope.row.ProfitSum / 100}元` }}</span>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div
          id="product-statistics-pie"
          class="pie-view">
        </div>
      </div>
      <el-pagination
        layout="prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        :page-size="5"
        :total="goodsAnalyseDataTotalNumer">
      </el-pagination>
    </div>

    <div class="title">
      <span>核心数据</span>
    </div>
    <div class="info-box">
      <el-select
        size="small"
        v-model="mainData.viewUnit"
        placeholder="请选择">
        <el-option
          v-for="item in mainUnitOptions"
          :key="'mainData' + item.value"
          :label="item.label"
          :value="item.value">
        </el-option>
      </el-select>
      <el-date-picker
        size="small"
        v-show="mainData.viewUnit === 'week'"
        v-model="mainData.dateTime"
        type="week"
        :picker-options="pickerOptions"
        format="yyyy 第 WW 周"
        placeholder="选择周">
      </el-date-picker>
      <el-date-picker
        size="small"
        v-show="mainData.viewUnit === 'month'"
        v-model="mainData.dateTime"
        :picker-options="pickerOptions"
        type="month"
        placeholder="选择月">
      </el-date-picker>
      <el-date-picker
        size="small"
        v-show="mainData.viewUnit === 'year'"
        v-model="mainData.dateTime"
        :picker-options="pickerOptions"
        type="year"
        placeholder="选择年">
      </el-date-picker>
      <el-date-picker
        size="small"
        v-show="mainData.viewUnit === 'customize'"
        v-model="mainData.startDate"
        type="date"
        :picker-options="pickerMainDataStartOptions"
        placeholder="开始时间">
      </el-date-picker>
      <el-date-picker
        size="small"
        v-show="mainData.viewUnit === 'customize'"
        v-model="mainData.endDate"
        type="date"
        :picker-options="pickerMainDataEndOptions"
        placeholder="结束时间">
      </el-date-picker>
      <!-- <el-button
        @click="changeDataTime('mainData')"
        class="update-button"
        size="mini"
        type="primary">
        <img src="../assets/image/home/update.png"/>刷新
      </el-button> -->
      <ul class="line-choose">
        <li
          @click="changeLineType('orderNum')"
          class="choose-item">
          <div class="choose-type">
            <img
              v-if="this.mainLineType === 'orderNum'"
              src="../assets/image/home/choose.png"/>
            <img
              v-else
              src="../assets/image/home/noChoose.png"/>
          </div>
          <div class="item-name">
            <div class="item-box">
              <img src="../assets/image/home/icon1.png"/>单数
            </div>
          </div>
        </li>
        <li
          @click="changeLineType('priceSum')"
          class="choose-item">
          <div class="choose-type">
            <img
              v-if="this.mainLineType === 'priceSum'"
              src="../assets/image/home/choose.png"/>
            <img
              v-else
              src="../assets/image/home/noChoose.png"/>
          </div>
          <div class="item-name">
            <div class="item-box">
              <img src="../assets/image/home/icon2.png"/>盈利（元）
            </div>
            <div class="item-box">
              <img src="../assets/image/home/icon3.png"/>保费（元）
            </div>
          </div>
        </li>
      </ul>
      <div
        :class="this.mainLineType === 'orderNum' ? '' : 'none'"
        class="info-view product-view">
        <div
          id="main-data-order-line"
          class="line-view">
        </div>
      </div>
      <div
        :class="this.mainLineType === 'priceSum' ? '' : 'none'"
        class="info-view product-view">
        <div
          id="main-data-price-line"
          class="price-line-view">
        </div>
      </div>
    </div>

  </div>
</template>

<script>
import { formatData, getLocalStorage } from '../utils/utils';
// 引入 ECharts 主模块
const echarts = require('echarts/lib/echarts');
// 引入柱状图
require('echarts/lib/chart/pie');
require('echarts/lib/chart/line');
// 引入提示框和标题组件
require('echarts/lib/component/tooltip');
require('echarts/lib/component/title');
require('echarts/lib/component/legend');

export default {
  name: 'Home',
  data() {
    return {
      formatData,
      mainLineType: 'orderNum',
      goodsAnalyseDataTotalNumer: 0,
      goodsAnalyseDataPage: 1,
      curDate: '',
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
      pickerInfoDataStartOptions: {
        disabledDate: (time) => {
          if (this.infoData.endDate !== '' && this.infoData.endDate) {
            const timeStr = new Date(this.infoData.endDate);
            const year = new Date(this.infoData.endDate.getTime() - (365 * 24 * 3600 * 1000));
            return time.getTime() > timeStr || time.getTime() < year || time.getTime() > Date.now();
          }
          return time.getTime() > Date.now();
        },
      },
      pickerInfoDataEndOptions: {
        disabledDate: (time) => {
          if (this.infoData.startDate !== '' && this.infoData.startDate) {
            const timeStr = new Date(this.infoData.startDate);
            const year = new Date(this.infoData.startDate.getTime() + (365 * 24 * 3600 * 1000));
            return time.getTime() < timeStr || time.getTime() > year || time.getTime() > Date.now();
          } else if (this.infoData.startDate === '') {
            return time.getTime() > Date.now();
          }
          return time.getTime() > Date.now();
        },
      },
      pickerProductDataStartOptions: {
        disabledDate: (time) => {
          if (this.productData.endDate !== '' && this.productData.endDate) {
            const timeStr = new Date(this.productData.endDate);
            const year = new Date(this.productData.endDate.getTime() - (365 * 24 * 3600 * 1000));
            return time.getTime() > timeStr || time.getTime() < year || time.getTime() > Date.now();
          }
          return time.getTime() > Date.now();
        },
      },
      pickerProductDataEndOptions: {
        disabledDate: (time) => {
          if (this.productData.startDate !== '' && this.productData.startDate) {
            const timeStr = new Date(this.productData.startDate);
            const year = new Date(this.productData.startDate.getTime() + (365 * 24 * 3600 * 1000));
            return time.getTime() < timeStr || time.getTime() > year || time.getTime() > Date.now();
          } else if (this.productData.startDate === '') {
            return time.getTime() > Date.now();
          }
          return time.getTime() > Date.now();
        },
      },
      pickerMainDataStartOptions: {
        disabledDate: (time) => {
          if (this.mainData.endDate !== '' && this.mainData.endDate) {
            const timeStr = new Date(this.mainData.endDate);
            const year = new Date(this.mainData.endDate.getTime() - (365 * 24 * 3600 * 1000));
            return time.getTime() > timeStr || time.getTime() < year || time.getTime() > Date.now();
          }
          return time.getTime() > Date.now();
        },
      },
      pickerMainDataEndOptions: {
        disabledDate: (time) => {
          if (this.mainData.startDate !== '' && this.mainData.startDate) {
            const timeStr = new Date(this.mainData.startDate);
            const year = new Date(this.mainData.startDate.getTime() + (365 * 24 * 3600 * 1000));
            return time.getTime() < timeStr || time.getTime() > year || time.getTime() > Date.now();
          } else if (this.mainData.startDate === '') {
            return time.getTime() > Date.now();
          }
          return time.getTime() > Date.now();
        },
      },
      infoData: {
        nowDate: new Date(),
        dateTime: new Date(),
        startDate: new Date(Date.now() - (30 * 24 * 3600 * 1000)),
        endDate: new Date(),
        viewUnit: 'now',
        stepUnit: 'day',
      },
      productData: {
        nowDate: new Date(),
        dateTime: new Date(),
        startDate: new Date(Date.now() - (30 * 24 * 3600 * 1000)),
        endDate: new Date(),
        viewUnit: 'now',
        stepUnit: 'day',
      },
      mainData: {
        dateTime: new Date(),
        startDate: new Date(Date.now() - (30 * 24 * 3600 * 1000)),
        endDate: new Date(),
        viewUnit: 'week',
        stepUnit: 'day',
      },
      unitOptions: [
        {
          label: '今日实时',
          value: 'now',
        },
        {
          label: '日视图',
          value: 'day',
        },
        {
          label: '周视图',
          value: 'week',
        },
        {
          label: '月视图',
          value: 'month',
        },
        {
          label: '年视图',
          value: 'year',
        },
        {
          label: '自定义日期',
          value: 'customize',
        },
      ],
      mainUnitOptions: [
        {
          label: '周视图',
          value: 'week',
        },
        {
          label: '月视图',
          value: 'month',
        },
        {
          label: '年视图',
          value: 'year',
        },
        {
          label: '自定义日期',
          value: 'customize',
        },
      ],
      totalAnalyseData: {},
      goodsAnalyseData: {},
      orderNumCurveData: {},
    };
  },
  created() {
    if (this.$route.params.dateType === 'yesterday') {
      this.infoData.viewUnit = 'day';
      this.infoData.dateTime = new Date(Date.now() - (24 * 3600 * 1000));
      this.productData.viewUnit = 'day';
      this.productData.dateTime = new Date(Date.now() - (24 * 3600 * 1000));
    }
    this.changeDataTime('infoData');
    this.changeDataTime('productData');
    this.changeDataTime('mainData');
  },
  mounted() {
  },
  computed: {
    infoDataViewUnit() {
      return this.infoData.viewUnit;
    },
    infoDataDateTime() {
      return this.infoData.dateTime;
    },
    infoDataStartDate() {
      return this.infoData.startDate;
    },
    infoDataEndDate() {
      return this.infoData.endDate;
    },
    productDataViewUnit() {
      return this.productData.viewUnit;
    },
    productDataDateTime() {
      return this.productData.dateTime;
    },
    productDataStartDate() {
      return this.productData.startDate;
    },
    productDataEndDate() {
      return this.productData.endDate;
    },
    mainDataViewUnit() {
      return this.mainData.viewUnit;
    },
    mainDataDateTime() {
      return this.mainData.dateTime;
    },
    mainDataStartDate() {
      return this.mainData.startDate;
    },
    mainDataEndDate() {
      return this.mainData.endDate;
    },
  },
  watch: {
    infoDataViewUnit() {
      this.changeDataTime('infoData');
    },
    infoDataDateTime() {
      this.changeDataTime('infoData');
    },
    infoDataStartDate() {
      if (this.infoData.startDate && this.infoData.endDate) {
        this.changeDataTime('infoData');
      }
    },
    infoDataEndDate() {
      if (this.infoData.startDate && this.infoData.endDate) {
        this.changeDataTime('infoData');
      }
    },
    productDataViewUnit() {
      this.changeDataTime('productData');
    },
    productDataDateTime() {
      this.changeDataTime('productData');
    },
    productDataStartDate() {
      if (this.productData.startDate && this.productData.endDate) {
        this.changeDataTime('productData');
      }
    },
    productDataEndDate() {
      if (this.productData.startDate && this.productData.endDate) {
        this.changeDataTime('productData');
      }
    },
    mainDataViewUnit() {
      this.changeDataTime('mainData');
    },
    mainDataDateTime() {
      this.changeDataTime('mainData');
    },
    mainDataStartDate() {
      if (this.mainData.startDate && this.mainData.endDate) {
        this.changeDataTime('mainData');
      }
    },
    mainDataEndDate() {
      if (this.mainData.startDate && this.mainData.endDate) {
        this.changeDataTime('mainData');
      }
    },
  },
  methods: {
    getTotalAnalyse(data) {
      this.$http.post('/admin/v1/analyse/totalAnalyse', data).then((res) => {
        if (res.Code === this.$requestCode.RESPONSE_SUCCESS.code) {
          this.totalAnalyseData = res.Data.TotalAnalyseData;
        } else {
          this.$requestStatus(res);
        }
      });
    },
    getGoodsAnalyse(data) {
      this.$http.post('/admin/v1/analyse/goodsAnalyse', data).then((res) => {
        if (res.Code === this.$requestCode.RESPONSE_SUCCESS.code) {
          this.goodsAnalyseData = res.Data.GoodsAnalyseData;
          if (this.goodsAnalyseData.GoodsItemList.length < 5) {
            for (let index = this.goodsAnalyseData.GoodsItemList.length; index < 5; index += 1) {
              this.goodsAnalyseData.GoodsItemList.push({
                GoodsName: '暂无数据',
                OrderNum: '暂无数据',
                PriceSum: '',
                ProfitSum: '',
              });
            }
          }
          this.goodsAnalyseDataTotalNumer = res.Data.TotalNumber;
          this.setProductPie();
        } else {
          this.$requestStatus(res);
        }
      });
    },
    getOrderCurveData(data) {
      this.$http.post('/admin/v1/analyse/orderCurveData', data).then((res) => {
        if (res.Code === this.$requestCode.RESPONSE_SUCCESS.code) {
          this.orderNumCurveData = res.Data.OrderNumCurveData;
          this.setMainLine();
        } else {
          this.$requestStatus(res);
        }
      });
    },
    upDateNowDate(type) {
      if (type === 'infoData') {
        this.infoData.nowDate = new Date();
        this.changeDataTime('infoData');
      }
      if (type === 'productData') {
        this.productData.nowDate = new Date();
        this.changeDataTime('productData');
      }
    },
    changeLineType(type) {
      this.mainLineType = type;
    },
    handleCurrentChange(val) {
      this.goodsAnalyseDataPage = val;
      this.changeDataTime('productData');
    },
    changeDataTime(type) {
      let viewData = {};
      if (type === 'infoData') {
        viewData = { ...this.infoData };
      }
      if (type === 'productData') {
        viewData = { ...this.productData };
      }
      if (type === 'mainData') {
        viewData = { ...this.mainData };
      }
      if (viewData.viewUnit === 'now' || viewData.viewUnit === 'day') {
        viewData.startDate = formatData(viewData.dateTime);
        viewData.endDate = formatData(viewData.dateTime);
        viewData.stepUnit = 'day';
      }
      if (viewData.viewUnit === 'week') {
        // 获取当前日期是周几
        const day = new Date(Date.parse(viewData.dateTime)).getDay();
        // 根据当前日期推算出周日和周六的时间（一周以周日开始，周六结束算）
        viewData.startDate = formatData(new Date(Date.parse(viewData.dateTime) - (day * 24 * 60 * 60 * 1000)));
        viewData.endDate = formatData(new Date(Date.parse(viewData.dateTime) + ((6 - day) * 24 * 60 * 60 * 1000)));
        viewData.stepUnit = 'day';
      }
      if (viewData.viewUnit === 'month') {
        const year = new Date(Date.parse(viewData.dateTime)).getFullYear();
        let month = new Date(Date.parse(viewData.dateTime)).getMonth() + 1;
        const lastDay = new Date(year, month, 0).getDate();
        if (month < 10) {
          month = `0${month}`;
        }
        viewData.startDate = `${year}-${month}-01`;
        viewData.endDate = `${year}-${month}-${lastDay}`;
        viewData.stepUnit = 'day';
      }
      if (viewData.viewUnit === 'year') {
        const year = new Date(Date.parse(viewData.dateTime)).getFullYear();
        viewData.startDate = `${year}-01-01`;
        viewData.endDate = `${year}-12-31`;
        viewData.stepUnit = 'month';
      }
      if (viewData.viewUnit === 'customize') {
        viewData.startDate = formatData(viewData.startDate);
        viewData.endDate = formatData(viewData.endDate);
        viewData.stepUnit = 'day';
      }
      const data = {
        PlatformCode: getLocalStorage('platformCode'),
        StartDate: viewData.startDate,
        EndDate: viewData.endDate,
        StepUnit: viewData.stepUnit,
      };
      if (type === 'infoData') {
        this.getTotalAnalyse(data);
      }
      if (type === 'productData') {
        data.CountPerPage = 5;
        data.Page = this.goodsAnalyseDataPage;
        this.getGoodsAnalyse(data);
      }
      if (type === 'mainData') {
        this.getOrderCurveData(data);
      }
    },
    setProductPie() {
      const legendData = [];
      const seriesData = [];
      let orderNumSum = 0;
      this.goodsAnalyseData.ClassItemList.map((item, index) => {
        orderNumSum = item.OrderNum + orderNumSum;
        return '';
      });
      let isClassItemListEmpty = true;
      this.goodsAnalyseData.ClassItemList.map((item, index) => {
        if (item.OrderNum !== 0) {
          isClassItemListEmpty = false;
        }
        legendData.push(item.ClassName);
        seriesData.push({
          value: item.OrderNum,
          name: item.ClassName,
        });
        return '';
      });
      // 基于准备好的dom，初始化echarts实例
      const productPie = echarts.init(document.getElementById('product-statistics-pie'));
      productPie.clear();
      // 绘制图表
      if (!isClassItemListEmpty) {
        productPie.setOption({
          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c}单（{d}%）',
          },
          legend: {
            orient: 'vertical',
            right: '1%',
            top: 90,
            icon: 'circle',
            data: legendData,
          },
          series: [
            {
              type: 'pie',
              radius: ['45%', '70%'],
              center: ['40%', '50%'],
              hoverAnimation: false,
              avoidLabelOverlap: true,
              label: {
                normal: {
                  show: true,
                  position: 'outside',
                },
                formatter: (label) => {
                  const data = label.data;
                  return data;
                },
              },
              data: seriesData,
              color: ['#409EFF', '#2DCD84', '#FFAB3E', '#F56C6C', '#6dd0f2'],
            },
          ],
        });
      } else {
        productPie.setOption({
          tooltip: {
            trigger: 'item',
            formatter: '{b}: {c}单（{d}%）',
          },
          series: [
            {
              type: 'pie',
              radius: ['45%', '70%'],
              center: ['40%', '50%'],
              hoverAnimation: false,
              avoidLabelOverlap: true,
              label: {
                normal: {
                  show: false,
                  position: 'outside',
                },
              },
              data: seriesData,
              color: ['#AAAAAA'],
            },
          ],
        });
      }
    },
    setMainLine() {
      const orderNumXAxisData = [];
      const priceSumXAxisData = [];
      const orderNum = [];
      const priceSum = [];
      const profitSum = [];
      this.orderNumCurveData.OrderNumCurveList.map((item, index) => {
        orderNumXAxisData.push(item.Date);
        orderNum.push(item.OrderNum);
        return '';
      });
      this.orderNumCurveData.PriceSumCurveList.map((item, index) => {
        priceSumXAxisData.push(item.Date);
        profitSum.push(item.ProfitSum / 100).toFixed(2);
        priceSum.push(item.PriceSum / 100).toFixed(2);
        return '';
      });
      // 基于准备好的dom，初始化echarts实例
      const orderDom = document.getElementById('main-data-order-line');
      const priceDom = document.getElementById('main-data-price-line');
      if (document.body.clientWidth > 1200) {
        orderDom.style.width = `${document.body.clientWidth * 0.75}px`;
        priceDom.style.width = `${document.body.clientWidth * 0.75}px`;
      } else {
        orderDom.style.width = `${1200 * 0.75}px`;
        priceDom.style.width = `${1200 * 0.75}px`;
      }
      const mainOrderNumDataLine = echarts.init(orderDom);
      const mainPriceSumDataLine = echarts.init(priceDom);
      mainOrderNumDataLine.clear();
      mainPriceSumDataLine.clear();
      // 绘制图表
      mainOrderNumDataLine.setOption({
        tooltip: {
          trigger: 'axis',
          position(pt) {
            return [pt[0], '10%'];
          },
        },
        xAxis: {
          type: 'category',
          data: orderNumXAxisData,
          axisLine: {
            lineStyle: {
              color: '#999',
              width: 1,
            },
          },
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: '#DCDCDC',
            },
          },
          axisLine: {
            lineStyle: {
              color: '#999',
              width: 1,
            },
          },
        },
        grid: {
          x: 50,
          xx2: 10,
          y: 30,
          width: '92%',
          containLabel: true,
        },
        series: [
          {
            data: orderNum,
            type: 'line',
            smooth: true,
            color: '#409EFF',
          },
        ],
      });

      mainPriceSumDataLine.setOption({
        tooltip: {
          trigger: 'axis',
          position(pt) {
            return [pt[0], '10%'];
          },
        },
        xAxis: {
          type: 'category',
          data: priceSumXAxisData,
          axisLine: {
            lineStyle: {
              color: '#999',
              width: 1,
            },
          },
        },
        yAxis: {
          type: 'value',
          splitLine: {
            show: true,
            lineStyle: {
              type: 'dashed',
              color: '#DCDCDC',
            },
          },
          axisLine: {
            lineStyle: {
              color: '#999',
              width: 1,
            },
          },
        },
        grid: {
          x: 50,
          xx2: 10,
          y: 30,
          width: '92%',
          containLabel: true,
        },
        series: [
          {
            data: profitSum,
            type: 'line',
            smooth: true,
            color: '#FFAB3E',
          },
          {
            data: priceSum,
            type: 'line',
            smooth: true,
            color: '#2DCD84',
          },
        ],
      });
    },
  },
};
</script>
<style lang="scss" scoped>
  .home-content {
    color: #303133;
    .title {
      font-size: 0.1rem;
      background: #F7F7F9;
      padding: 0.1rem 0.26rem;
      color: #2F3133;
      span {
        border-left: 2px solid #3B8DE3;
        padding-left: 0.1rem;
      }
    }
    .info-box {
      padding: 0.1rem 0.26rem;
      .update-time {
        margin: 0 0.22rem 0 0.1rem;
      }
      .update-button {
        img {
          width: 8px;
          margin: 0 8px 0 0;
        }
      }
      .info-view {
        display: flex;
        justify-content: space-between;
        margin-top: 0.1rem;
        .info-item {
          position: relative;
          .bg {
            width: 2.42rem;
          }
          .info-text {
            position: absolute;
            top: 50%;
            left: 0.21rem;
            transform: translate(0, -50%);
            color: #fff;
            .order-number {
              font-size: 0.21rem;
              font-weight: bold;
              margin-bottom: 0.03rem;
            }
            .info-title {
              font-size: 0.14rem;
            }
          }
        }
      }
      .product-view {
        justify-content: flex-start;
      }
      .table {
        max-width: 800px;
        flex: 1;
        overflow-x: auto;
        margin-right: 0.42rem;
      }
      .pie-view {
        width: 500px;
        height: 300px;
      }
      .el-pagination {
        margin-top: 10px;
      }
      .line-view {
        width: 100%;
        height: 360px;
      }
      .price-line-view {
        width: 100%;
        height: 360px;
      }
      .line-choose {
        display: flex;
        justify-content: flex-end;
        align-items: flex-start;
        padding-right: 0.5rem;
        .choose-item {
          display: flex;
          align-items: flex-start;
          margin-right: 0.18rem;
          &:last-child {
            margin: 0;
          }
          .choose-type {
            width: 0.08rem;
            margin: 0.01rem 0.05rem 0 0;
            img {
              width: 100%;
            }
          }
          .item-name {
            font-size: 0.06rem;
            img {
              width: 0.14rem;
            }
            .item-box {
              display: flex;
              align-items: center;
              margin-bottom: 0.02rem;
            }
          }
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue